<template>
  <section class="detail-intro">
    <div class="detail-intro__card">
      <div v-if="detail.gallery && detail.gallery.length" class="detail-intro__gallery">
        <el-carousel
          :interval="5000"
          arrow="always"
          indicator-position="outside"
          height="320px"
        >
          <el-carousel-item v-for="(img, index) in detail.gallery" :key="index">
            <img :src="img" :alt="detail.title" class="detail-intro__image" />
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="detail-intro__content">
        <h2 class="detail-intro__title">{{ detail.title }}</h2>
        <dl class="detail-intro__meta">
          <div v-if="detail.eventType" class="detail-intro__meta-row">
            <dt>展览类型：</dt>
            <dd>{{ detail.eventType }}</dd>
          </div>
          <div v-if="detail.eventDate" class="detail-intro__meta-row">
            <dt>发布时间：</dt>
            <dd>{{ detail.eventDate }}</dd>
          </div>
        </dl>
        <p class="detail-intro__desc">{{ detail.intro }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DetailIntro',
  props: {
    detail: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-intro {
  margin-bottom: $spacing-3xl;

  &__card {
    display: flex;
    gap: $spacing-xl;
    padding: $spacing-xl;
    background: $color-white;
    border-radius: 4px;
    box-shadow: 0 4px 24px rgba($color-brown-dark, 0.08);
  }

  &__gallery {
    width: 48%;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
  }

  &__image {
    width: 100%;
    height: 320px;
    object-fit: cover;
    filter: grayscale(0.3) sepia(0.15);
  }

  &__content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(28);
    font-weight: 700;
    color: $color-brown-dark;
    margin-bottom: $spacing-base;
    letter-spacing: 2px;
  }

  &__meta {
    margin-bottom: $spacing-base;
    padding-bottom: $spacing-base;
    border-bottom: 1px solid rgba($color-border, 0.5);
  }

  &__meta-row {
    display: flex;
    font-size: rem(14);
    line-height: 2;

    dt {
      color: $color-text-light;
      flex-shrink: 0;
    }

    dd {
      color: $color-text;
    }
  }

  &__desc {
    font-size: rem(14);
    line-height: 1.9;
    color: $color-text-light;
    flex: 1;
  }
}

@media (max-width: 960px) {
  .detail-intro {
    &__card {
      flex-direction: column;
    }

    &__gallery {
      width: 100%;
    }
  }
}
</style>
